

<div class="login-bg1  h-100"  >
  <div class="container">
    <div class="row pt-5">
      <div class="col-md-4 offset-md-2">
        <div class="mt-4">
          <img src="assets/img/logo.png" alt="logo">
        </div>
        <div class="py-4">
          <h2 class="font-weight-bold form-text" >WELCOME
          </h2>
          <h5  class=" form-text" >Partner Login</h5>
        </div>
        <p class="form-text">To request an account  Just Call or Email Us</p>
        <div class="">
          <h3 class="border-no mb-4" style="letter-spacing: 6px;">+917337327109</h3>
          <h3 class="border-no"> care@fastswiff.com</h3>
        </div>
        <div class="social-icons py-4">
          <a  href="https://www.facebook.com/FastSwiffIndia/" target="_blank" ><i class="fab fa-facebook"></i></a>  <a href="https://twitter.com/FastSwiffIndia"  target="_blank"><i class="fab fa-twitter"></i></a>
          <a href="https://www.instagram.com/paygindia/"  target="_blank"><i class="fab fa-instagram"></i></a>
          <a href="https://www.linkedin.com/company/pay-g"  target="_blank"><i class="fab fa-linkedin-in"></i></a>
          <a href="https://www.youtube.com/watch?v=IEbSqP5Q18Y"  target="_blank"><i class="fab fa-youtube"></i></a>
          <a href="https://in.pinterest.com/paygindia/"  target="_blank"><i class="fab fa-pinterest-p"></i></a>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-login">
          <div class=" ">
            <div class="card login-form shadow"  >
            <div class="card-body front">
              <h3 class="card-title font-weight-bold">Log in</h3>
              <div class="card-text">
              <!-- <p>This secure system is only available for merchants, please provide merchant credentials below </p> -->
              <p>Login to continue to PAY-G Dashboard</p>
                <form  #loginform="ngForm">
                  <div class="form-group ">
                    <div data-validate="Valid email is required: ex@abc.xyz">
                      <input type="text" placeholder="Email"  id="email" name="email" [formControl]="email" required class="form-control login-input form-control-sm">
                    </div>
                  </div>
                  <div class="form-group">
                    <div   data-validate="Password is required">
                      <input  class="form-control  login-input form-control-sm" placeholder="Password"  type="password" id="password" name="password" aria-label="password"
                      [formControl]="password" required>
                    </div>
                    <span class="text-danger"
                  *ngIf="password.invalid && (password.dirty || password.touched)">{{passworderrors()}} </span>
                <!-- validations content -->
                <small style="color:red;" *ngIf="isloginfailed">UserName or Password is Invalid</small>
                <small style="color:red;" *ngIf="isPasswordExpired">password expired</small>
                <small style="color:red;" *ngIf="!isValidMerchant">Merchant Id was not found with given details</small>
                <small style="color:red;" *ngIf="isMerchantNotActive">Entered Merchant Id is not an Active</small>
  
                <small style="color:red;" *ngIf="isAccountRejected">Your Account was Rejected</small>
                <small style="color:red;" *ngIf="isAccountVerificationPending">Verification pending for your
                  Account</small>
  
                <small style="color:red;" *ngIf="isAccountOnHold">Sorry!, You can not login now due to your account was
                  OnHold</small>
                <small style="color:red;" *ngIf="isAccountCancled">Sorry!, You can not login due to your account was
                  Cancelled</small>
                <small style="color:red;" *ngIf="isAccountDeclined">Sorry!, You can not login due to your account was
                  Declined</small>
                  <small style="color:red;" *ngIf="isEmailConfirmationPending">Email Confirmation is pending, please check your Email to continue with us.
                    </small>

                    <!-- validationns -->

                    <!-- <a [routerLink]="['/registration/forgotpassword']" class="text-danger py-1" style="float:right;font-size:12px;">Forgot password?</a> -->
                  </div>
                  <!-- <button type="submit" class="damke_siteBtn  btn-block"  [disabled]="isformvalid()||email.invalid || password.invalid">Log in</button> -->
                  
                  <!-- <div class="sign-up">
                    Don't have an account?  
                    <button class="damke_siteBtn p-1 btn-block" [routerLink]="['/registration/new']">
                      Click here to create Merchant
                    </button>
                    <div class=" pt-1">
                      <button class="damke_siteBtn p-1 btn-block" [routerLink]="['/user/registeruser']" >
                        Click here to create Merchant User
                      </button>
                    </div>
                  </div> -->

                </form>
              </div>
            </div> 
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
